export default "__VITE_ASSET__CF$zizOs__"